import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  initialSitewideDashboardFiltersState,
  ISitewideDashboardFilters,
} from "../types/sitewideDashboardFilters";

const slice = createSlice({
  name: "sitewideDashboardFilters",
  initialState: initialSitewideDashboardFiltersState,
  reducers: {
    clearSitewideDashboardFilters: (sitewideDashboardFilters) => {
      Object.assign(
        sitewideDashboardFilters,
        initialSitewideDashboardFiltersState
      );
    },
    setSitewideDashboardFilter: (
      sitewideDashboardFilters,
      action: PayloadAction<ISitewideDashboardFilters>
    ) => {
      Object.assign(sitewideDashboardFilters, action.payload);
    },
    updateSitewideDashboardFilter: (
      sitewideDashboardFilters,
      action: PayloadAction<{
        key: keyof ISitewideDashboardFilters;
        value: any;
      }>
    ) => {
      Object.assign(sitewideDashboardFilters, {
        ...sitewideDashboardFilters,
        [action.payload.key]: action.payload.value,
      });
    },
  },
});

export const {
  updateSitewideDashboardFilter,
  setSitewideDashboardFilter,
  clearSitewideDashboardFilters,
} = slice.actions;

export const sitewideDashboardFiltersReducer = slice.reducer;
